import { MAINTENANCE, appActions } from 'app/pages/App/slice';
import axios, {
  AxiosError,
  AxiosInstance,
  AxiosPromise,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios';
import Qs from 'qs';
import { notify } from 'reapop';
import { objectType } from 'types';
import { escapeHTML } from 'utils/helper';
import { store } from '../';
import { DEFAULT_LANGUAGE, SYSTEM_MAINTENANCE, TYPE_COOKIE } from './constants';
import { getCookie, removeCookie } from './cookies';
import { CANCEL_ORDER_ERROR_CODE } from 'app/pages/TicketRefund/pages/TicketRefundDetail';
import { ADJUST_ORDER_ERROR_CODE } from 'app/pages/Checkout/components/EditOrderPopup';
// import { appActions } from 'app/pages/App/slice';

declare module 'axios' {
  export interface AxiosRequestConfig {
    skipErrorNotify?: boolean;
  }
  export interface InternalAxiosRequestConfig {
    skipErrorNotify?: boolean;
  }
}

export const KEY_NOTIFICATION = 'KEY';
export const KEY_NOTIFICATION_PUT = 'PUT';
export const KEY_NOTIFICATION_POST = 'POST';
export const KEY_NOTIFICATION_DELETE = 'DELETE';

const AIPM_TOKEN = process.env.REACT_APP_AIPM_TOKEN;
let IS_SHOW_NOTIFICATION = false;

const urlsToCancel = ['show/list-show'];

const pendingRequests = new Map();

const onSuccessInterceptorRequest = async (
  config: InternalAxiosRequestConfig<any>,
) => {
  const token = getCookie(TYPE_COOKIE.TOKEN);
  const language = getCookie(TYPE_COOKIE.LANGUAGE) || DEFAULT_LANGUAGE;

  const whiteIp = localStorage.getItem('white-list-ip');

  // config.headers = {};
  config.url = `/${language}/api/${config.url}`;

  if (!AIPM_TOKEN) {
    if (token && config && config.headers)
      config.headers.Authorization = `${token}`;
  } else {
    if (config && config.headers) {
      if (token) {
        config.headers.setAuthorization(`${token}`);
        config.headers.set(`apim-sub-key`, `${AIPM_TOKEN}`);
        // config.headers = {
        //   Authorization: `${token}`,
        //   [`apim-sub-key`]: `${AIPM_TOKEN}`,
        // };
      } else {
        config.headers.set(`apim-sub-key`, `${AIPM_TOKEN}`);
        // config.headers = {
        //   [`apim-sub-key`]: `${AIPM_TOKEN}`,
        // };
      }
    }
  }
  if (whiteIp) {
    config.headers.set('white-list-ip', `${whiteIp}`);
  }
  config.headers.set('Cache-Control', 'no-cache');
  if (
    config.url.includes('/download-pdf/') ||
    config.url.includes('/download-ticket-pdf') ||
    config.url.includes('/download-pdf-cms/') ||
    config.url.includes('/download-multiple-ticket-pdf')
  ) {
    config.headers['Content-Type'] = 'application/pdf';
    config.responseType = 'arraybuffer';
  }
  config.paramsSerializer = (params: any) =>
    Qs.stringify(params, {
      arrayFormat: 'indices',
    });

  if (urlsToCancel.includes(config.url) && pendingRequests.has(config.url)) {
    const cancel = pendingRequests.get(config.url);
    cancel();
    pendingRequests.delete(config.url);
  }

  if (urlsToCancel.includes(config.url)) {
    const source = axios.CancelToken.source();
    config.cancelToken = source.token;
    pendingRequests.set(config.url, source.cancel);
  }

  return config;
};
const onErrorInterceptorRequest = (error: AxiosError) => Promise.reject(error);

let notif;
const includesSome = (url = '', patterns: string[]) =>
  patterns.some(pattern => url.includes(pattern));

const logout = () => {
  removeCookie(TYPE_COOKIE.TOKEN);
  store.dispatch(appActions.logout({}));
};
const ERROR_IGNORE_URLS = [
  '/b2b/v1/cart/get-price',
  'b2b/v1/cart/remove',
  'b2b/v1/cart/merge-new-item',
  'b2b/v1/order/cancel',
  'b2b/v1/cart/update',
  'b2b/v1/cart/add',
  'b2b/v1/order/detail',
  'b2b/v1/topup/detail',
  'b2b/v1/order/transactions-csv',
  'b2b/v1/item/listing-csv',
  'b2b/v1/topup/listing-csv',
  'b2b/holiday/search/combo',
  'b2b/reservation/booking/update-states',
  'b2b/v1/checkout/recover-order-upgrade',
  'b2b/v1/show/performances-by-restaurant',
  'b2b/v1/ticket/get-order-return-ticket',
  '/b2b/v1/checkout/pre-upgrade',
];

const SUCCESS_IGNORE_URLS = [
  'customer',
  'b2b/v1/order/list-approval',
  'b2b/v1/checkout/approve-payment',
  '/account/update',
  '/b2c/checkout/validate-payment',
  '/b2b/v1/cart/get-price',
  '/b2b/v1/cart/add',
  '/b2b/v1/cart/update',
  '/b2b/auth',
  'b2b/v1/order/update',
  'b2b/v1/checkout/payment',
  'b2b/v1/order/cancel',
  'b2b/v1/agency/change-status',
  'b2b/v1/agency/create',
  'b2b/v1/business-partner/banlce-info',
  'b2b/v1/order/detail',
  'b2b/v1/cart/get-inventory',
  'b2b/v1/order/pending-countdown',
  'b2b/v1/ticket/sync-status',
  '/b2b/v1/checkout/pre-upgrade',
  'b2b/v1/ticket/get-return-tickets',
  'b2b/v1/ticket/create-return-tickets',
  'b2b/reservation/ticket/add-ticket-to-reservation',
  'show/get-used-area2',
  'b2b/v1/ticket/cancel-order-return-ticket',
  'b2b/v1/ticket/approve-order-return-ticket',
  'b2b/v1/show/performances-by-restaurant',
  'b2b/v1/checkout/recover-order-upgrade',
  'b2b/v1/show/get-used-area2',
  'b2b/v1/topup/get-url',
  'b2b/v1/topup/detail?id=',
  'b2b/holiday/dashboard',
  'b2b/holiday/search/combo',
  'b2b/holiday/search/flights',
  'b2b/holiday/common/flight-segment/search',
  'b2b/holiday/order/cancel',
  'b2b/holiday/order/confirm-price',
  'b2b/v1/cart/check-config',
  'b2b/reservation/v2/booking/payment',
  'b2b/reservation/v2/booking/approve-payment',
  'b2b/reservation/v2/booking/availability',
];
const FILE_EXPORT_IGNORE_NOTIFY = [
  'b2b/v1/order/deposit-csv',
  'b2b/v1/order/credit-csv',
  'b2b/v1/order/penalty-csv',
];
const shouldIgnoreErrorNotify = (error: AxiosError<any>) => {
  const response = error.response;
  if (!response) return false;
  const url = response.config?.url || '';
  const data = response.data;
  const errorData = data?.data;
  if (
    data?.errorCode === SYSTEM_MAINTENANCE ||
    data?.action === 'popup' ||
    ['Đăng nhập để tiếp tục', 'Sign in to continue'].includes(data?.message) ||
    includesSome(url, ERROR_IGNORE_URLS) ||
    ['errorTicket', 'errorTime'].includes(errorData?.errorType) ||
    errorData?.errorCode === 'MSG075' ||
    window.location.pathname.includes('/order/edit')
  ) {
    return true;
  }
  const isBadRequestIgnored =
    [
      'b2b/v1/checkout/upgrade',
      'b2b/v1/ticket/create-return-tickets',
      'b2b/v1/checkout/approve-payment',
      'b2b/v1/ticket/get-return-tickets',
    ].some(path => url.includes(path)) && data?.code === 400;
  if (isBadRequestIgnored) return true;
  const isUpdatePasswordError =
    url.includes('b2b/auth/update-password') &&
    (errorData?.errorCode ||
      ['old_password', 'password_repeat'].includes(data?.field));
  if (isUpdatePasswordError) return true;
  if (url.includes('b2b/v1/order/update') && errorData?.code === 'MSG022') {
    return true;
  }
  const isCancelReturnTicketError =
    url.includes('b2b/v1/ticket/cancel-order-return-ticket') &&
    [
      CANCEL_ORDER_ERROR_CODE.CANCELLED,
      CANCEL_ORDER_ERROR_CODE.APPROVED,
    ].includes(errorData?.errorCode);
  if (isCancelReturnTicketError) return true;
  const isAdjustOrderError =
    url.includes('b2b/v1/checkout/adjust-order') &&
    [
      ADJUST_ORDER_ERROR_CODE.NOT_ENOUGH_INVENTORY,
      ADJUST_ORDER_ERROR_CODE.MAX_QUANTITY_FOC,
      ADJUST_ORDER_ERROR_CODE.NO_EDIT_ENTRANCE_TICKET,
    ].includes(errorData?.code);
  return isAdjustOrderError;
};
const onErrorInterceptorResponse = (error: AxiosError<objectType>) => {
  if (!error.response) {
    return Promise.reject(error);
  }
  const { status, data, config } = error.response;
  const url = config?.url || '';
  if (config?.skipErrorNotify) {
    if (status === 401) {
      logout();
    }
    return Promise.reject(error);
  }
  if (data?.errorCode === SYSTEM_MAINTENANCE) {
    const state = store.getState() as any;
    if (!state?.app?.maintenance?.data?.isMaintain) {
      store.dispatch(MAINTENANCE());
    }
    return Promise.reject(SYSTEM_MAINTENANCE);
  }
  if (shouldIgnoreErrorNotify(error)) {
    if (status === 401) {
      logout();
    }
    return Promise.reject(data);
  }
  const isIgnoreNotifyFile = includesSome(url, FILE_EXPORT_IGNORE_NOTIFY);
  if (!IS_SHOW_NOTIFICATION && !isIgnoreNotifyFile) {
    IS_SHOW_NOTIFICATION = true;
    const translation = (store.getState().app as any)?.translations;
    let errorMessage = data?.message || '';
    if (status === 403) {
      errorMessage = translation?.['b2b.txt.noPermission'] || '';
    }
    store.dispatch(
      notify(escapeHTML(errorMessage), 'error', {
        title: 'Oops',
        dismissAfter: 5000,
        onDismiss: () => {
          IS_SHOW_NOTIFICATION = false;
        },
      }),
    );
  }
  if (status === 401) {
    logout();
  }
  return Promise.reject(error);
};
const onSuccessInterceptorResponse = (response: AxiosResponse) => {
  const { status, config, data } = response;
  const url = config?.url || '';
  const shouldShowSuccess =
    status === 200 &&
    config.method !== 'get' &&
    !includesSome(url, SUCCESS_IGNORE_URLS) &&
    window.location.pathname !== '/cart' &&
    !window.location.pathname.includes('/order/edit') &&
    !data?.errorTickets?.length;
  if (shouldShowSuccess && !notif) {
    notif = store.dispatch(
      notify('Thành công.', 'success', {
        title: 'Success',
        dismissAfter: 2000,
      }),
    );
    setTimeout(() => {
      notif = null;
    }, 2000);
  }
  return response;
};

axios.defaults.headers.post['Accept'] = 'application/json';

const _axios: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
  timeout: 120 * 1000,
  // withCredentials: true, // Check cross-site Access-Control
});

_axios.interceptors.request.use(
  onSuccessInterceptorRequest,
  onErrorInterceptorRequest,
);

_axios.interceptors.response.use(
  onSuccessInterceptorResponse,
  onErrorInterceptorResponse,
);

/**
 *
 * @NOTE primary methods axios
 *
 */
class AxiosXHRConstructor {
  axiosInstance: AxiosInstance;
  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
    this.$get = this.$get.bind(this);
    this.$post = this.$post.bind(this);
    this.$put = this.$put.bind(this);
    this.$delete = this.$delete.bind(this);
  }
  public $get<T = any>(
    url: string,
    params?: objectType,
    config?: objectType,
  ): AxiosPromise<T> {
    checkOnlineState();
    return this.axiosInstance.get(url, {
      ...{ params },
      ...config,
    });
  }
  public $post<T = any>(
    url: string,
    data?: objectType,
    config?: objectType,
  ): AxiosPromise<T> {
    checkOnlineState();
    return this.axiosInstance.post(url, data, config);
  }
  public $put(
    url: string,
    data?: objectType,
    config?: objectType,
  ): AxiosPromise {
    checkOnlineState();
    return this.axiosInstance.put(url, data, config);
  }
  public $delete(url: string, data?: objectType): AxiosPromise {
    checkOnlineState();
    // return this.axiosInstance.delete(url, {
    //   data,
    // });

    /**
     * @hotfix {https://github.com/axios/axios/issues/3220}
     */
    return this.axiosInstance.request({
      method: 'delete',
      url,
      data,
    });
  }
}

export const BaseXHR = new AxiosXHRConstructor(_axios);

export default _axios;

const checkOnlineState = () => {
  const isOnline = navigator.onLine;
  if (!isOnline) {
    // Respect callers who intentionally set SKIP_OFFLINE_DIALOG to avoid re-opening
    try {
      const skip = sessionStorage.getItem('SKIP_OFFLINE_DIALOG');
      if (skip === '1') return Promise.reject();
    } catch (e) {}

    const translation = (store.getState().app as any)?.translations;

    store.dispatch(
      appActions.openDialogNoti({
        type: 'ERROR',
        isShow: true,
        title: translation ? translation['b2c.action.failed'] : '',
        content: translation ? translation['b2c.message.tryNetwork'] : '',
        closable: true,
        maskClosable: true,
        onCloseDialog: () => {
          try {
            sessionStorage.removeItem('SKIP_OFFLINE_DIALOG');
          } catch (e) {}
          store.dispatch(appActions.closeDialogNoti());
        },
        buttons: [
          {
            text: translation ? translation['b2c.btn.retry'] : '',
            bg: 'linear-gradient(79.97deg, #F06F24 -7.79%, #F8B117 107.61%)',
            color: 'white',
            onClick: () => {
              try {
                sessionStorage.removeItem('SKIP_OFFLINE_DIALOG');
              } catch (e) {}
              store.dispatch(appActions.closeDialogNoti());
            },
          },
        ],
      }),
    );
    return Promise.reject();
  }
};
